// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { BankDebt } from '@client/banks/types/debt';
import { BankDebtProductType } from '@client/banks/types/debt';
import { formatToMoney } from '@shared/ui-kit/utils/format-to-money';

/**
 * Outstanding amount shown in debt list rows.
 *
 * @remarks
 * Credit lines prefer `disposed`; loans use `pendingAmount`.
 */
export const getBankDebtOutstandingAmount = (
  debt: BankDebt,
): number | undefined => {
  if (debt.productType === BankDebtProductType.CreditLine) {
    return debt.disposed ?? debt.pendingAmount;
  }

  return debt.pendingAmount;
};

export const formatDebtPendingAmount = (
  pendingAmount: number | undefined,
  currency: string,
): string => {
  if (pendingAmount === null) {
    return '-';
  }

  const code = currency;

  return formatToMoney(pendingAmount, code, 2);
};

export const formatBankDebtOutstandingAmount = (debt: BankDebt): string =>
  formatDebtPendingAmount(getBankDebtOutstandingAmount(debt), debt.currency);
